// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-tel-input .flag-dropdown, .react-tel-input .form-control{\n  background: transparent;\n  border: none;\n}\n\n.react-tel-input .flag-dropdown{\n\n}", ""]);
// Exports
module.exports = exports;
